<div class="cockpit-content">
  <h1>{{card.title | translate}}</h1>
  <div class="cockpit-view">
    <div class="table-wrapper">

      <h4>{{'i18n.cockpit.card.chart.personalaufwand.lohnsummeNachGeschlecht' | translate}}</h4>

      <app-chart-download-button (buttonClick)="exportTable()">
        <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
      </app-chart-download-button>
      <table>
        <tr>
          <td class="no-border">&nbsp;</td>
          <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right border-bold-left">
            <span class="strong"> {{'i18n.cockpit.card.chart.personalaufwand.effektiv' | translate }}</span>
          </th>
          <th scope="colgroup" colspan="2" class="header centered bold border-bold-left border-bold-right">
            <span class="strong">{{'i18n.cockpit.card.chart.personalaufwand.standardisiert' | translate }}</span>
          </th>
        </tr>

        <tr>
          <th scope="col" class="header centered bold border-bold-left border-bold-right border-bold-left border-bold-right"><span class="strong">{{ 'i18n.common.geschlecht' |
              translate }}</span></th>
          <th scope="col" class="centered">{{ 'i18n.common.absolut' | translate }}</th>
          <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
          <th scope="col" class="centered">{{ 'i18n.common.absolut' | translate }}</th>
          <th scope="col" class="centered border-bold-right">{{ 'i18n.common.anteile' | translate }}</th>
        </tr>

        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{'i18n.common.maenner' | translate }}
          </th>
          <td>{{ lohnsumme.bezahlteLohnsummeMaenner | numberFormat: crtLocale }}</td>
          <td class="border-bold-right">{{ lohnsumme.bezahlteLohnsummeMaennerProzent }}</td>
          <td>{{ lohnsumme.standardisierteLohnsummeMaenner | numberFormat: crtLocale }}</td>
          <td class="border-bold-right">{{ lohnsumme.standardisierteLohnsummeMaennerProzent }}</td>
        </tr>

        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right">
            {{'i18n.common.frauen' | translate }}
          </th>
          <td>{{ lohnsumme.bezahlteLohnsummeFrauen | numberFormat: crtLocale }}</td>
          <td class="border-bold-right">{{ lohnsumme.bezahlteLohnsummeFrauenProzent }}</td>
          <td>{{ lohnsumme.standardisierteLohnsummeFrauen | numberFormat: crtLocale }}</td>
          <td class="border-bold-right">{{ lohnsumme.standardisierteLohnsummeFrauenProzent }}</td>
        </tr>

        <tr class="content">
          <th scope="row" class="border-bold-left border-bold-right border-bold-top">
            {{'i18n.common.total' | translate }}
          </th>
          <td class="border-bold-top">{{ lohnsumme.bezahlteLohnsummeMitarbeitende | numberFormat: crtLocale }}</td>
          <td class="border-bold-right border-bold-top">{{ lohnsumme.bezahlteLohnsummeMitarbeitendeProzent }}</td>
          <td class="border-bold-top">{{ lohnsumme.standardisierteLohnsummeMitarbeitende | numberFormat: crtLocale }}</td>
          <td class="border-bold-right border-bold-top">{{ lohnsumme.standardisierteLohnsummeMitarbeitendeProzent }}</td>
        </tr>
        <tr class="hint">
          <td class="hint" colspan="5">{{'m1-m2.sprint10.cockpit.card.hinveise-grundgesamtheit-gueltig' | translate}}</td>
        </tr>
        <tr class="hint">
          <td class="hint" colspan="5">
            {{'i18n.cockpit.card.chart.personalaufwand.ohneArbeitgeberbetraege' | translate }}
          </td>
        </tr>
      </table>

    </div>

    <div class="pdt-20">
      <h5>{{ 'sprint9.cockpit.card.all.diagramm' | translate }}</h5>
      <h6>{{ 'sprint9.cockpit.card.all.ansichteinstellung' | translate }}</h6>

      <div style="display: flex; justify-content: start; flex-direction: row;">
        <div>
          <mat-button-toggle-group #btngroupAbsolutAnteil="matButtonToggleGroup" appearance="standard"
            id="btnTogglegroupAbsolutAnteil" name="btnTogglegroupAbsolutAnteil" [value]="absolut"
            aria-label="Absolut or Anteil">
            <mat-button-toggle value="{{absolut}}" (change)="selectionAbsolutAnteilChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.absolut' | translate}}</small>
            </mat-button-toggle>

            <mat-button-toggle value="{{anteil}}" (change)="selectionAbsolutAnteilChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.anteil' | translate}}</small>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="diagram-margin">
          <mat-button-toggle-group #groupGestapeltUngestepelt="matButtonToggleGroup" appearance="standard"
            id="btnTogglegroupGestapeltUngestepelt" name="btnTogglegroupGestapeltUngestepelt" [value]="ungestapelt"
            aria-label="Ungestepelt or Gestapelt">
            <mat-button-toggle value="{{ungestapelt}}" (change)="selectionGestapeltUngestepeltChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.ungestapelt' | translate}}</small>
            </mat-button-toggle>
            <mat-button-toggle value="{{gestapelt}}" (change)="selectionGestapeltUngestepeltChanged($event)">
              <small>{{ 'i18n.cockpit.card.chart.gesamtverdienstLohn.gestapelt' | translate}}</small>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div id="svgContainerChartDialogPersonalaufwand" class="width-max-100-perc" ></div>
    </div>
  </div>
</div>
